import { selectorFamily } from "recoil"
import { getOutboxContacts } from "src/apis/contact/getOutboxContacts"
import { outboxContactsRequestIdState } from "src/recoil/atoms/contact/outboxContactsRequestIdState"
import { tokensState } from "src/recoil/atoms/authorization/tokensState"
import { selectedMyOrganizationSelector } from "src/recoil/selectors/organization/selectedMyOrganizationSelector"
import { ContactFilterValue } from "src/types/contact/ContactFilter"
import { CustomAlert } from "src/utils/CustomAlert"
import { myProfileSelectorFamily } from "src/recoil/selectors/organization/myProfile/myProfileSelectorFamily"
import { ContactOverviewModel } from "src/types/contact/ContactOverviewModel"
import { accountIdState } from "src/recoil/atoms/account/accoutnIdState"
import { multiTeamMemberImageUrls } from "src/apis/team/getMemberImageUrl"

interface TeamMemberImageType {
  isDefault?: boolean
  teamMemberId: string
  url: string
}

export const outboxContactsSelectorFamily = selectorFamily<
  { contacts: ContactOverviewModel[]; nextToken?: string } | undefined,
  { searchText?: string; filters?: ContactFilterValue[]; count?: number; nextToken?: string }
>({
  key: "selectors/contact/outboxContactsSelectorFamily",
  get:
    ({ filters, searchText, count, nextToken }) =>
    async ({ get }) => {
      get(outboxContactsRequestIdState)
      const selectedMyOrganization = get(selectedMyOrganizationSelector)
      if (selectedMyOrganization == null) {
        return
      }
      const tokens = get(tokensState)
      const accessToken = tokens?.accessToken
      if (accessToken == null) {
        return
      }
      const accountId = get(accountIdState)
      if (accountId == null) {
        return
      }
      const myProfile = get(myProfileSelectorFamily(selectedMyOrganization.id))
      console.log(selectedMyOrganization.id)
      if (myProfile == null) {
        return
      }
      const result = await getOutboxContacts({
        accessToken,
        myMemberId: myProfile.memberId,
        myMemberRole: myProfile.memberType,
        filters,
        searchText,
        organizationId: selectedMyOrganization.id,
        count,
        nextToken,
      })
      if (!result.isOk) {
        CustomAlert.alert("エラー", result.error.message)
        return
      }

      const uniqueSenders: any = {}
      const expect: any = []
      result.content.contacts.forEach((item) => {
        if (!uniqueSenders[item.senderId]) {
          uniqueSenders[item.senderId] = true
          expect.push({
            teamMemberId: item.senderId,
            thumbnail: false,
          })
        }
      })

      const dataImages = await multiTeamMemberImageUrls({
        accessToken: accessToken,
        teamMemberImages: expect,
      })
      let teamMemberImage: TeamMemberImageType[] = []
      if (dataImages.isOk) teamMemberImage = dataImages.content
      console.log(teamMemberImage)

      const accountImageMap: Record<string, string> =
        teamMemberImage?.reduce((map, ele) => {
          const baseUrl = ele.url.split("?")[0]
          return {
            ...map,
            [ele.teamMemberId]: baseUrl,
          }
        }, {}) ?? {}

      const resultAddImageUrl = result.content.contacts.map((item) => {
        return {
          ...item,
          imgUrl: `${accountImageMap[item.senderId ?? ""] ?? "default/account/image/profile.png"}?${new Date().getTime()}`,
        }
      })

      const mixResult = { contacts: resultAddImageUrl, nextToken: result.content.nextToken }

      return mixResult

      // return result.content
    },
})
